export type TalentPoolStep =
  | 'landing'
  | 'personal'
  | 'preferences'
  | 'submit'
  | 'thankyou'

export type UploadPickerTrigger = 'mouse' | 'keyboard'

export const TALENT_POOL_STEP_ORDER: TalentPoolStep[] = [
  'landing',
  'personal',
  'preferences',
  'submit',
  'thankyou',
]
